import React, { useEffect, useRef, useState } from "react";

// MODULES
//import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// STYLES
import "./Reports.scss";

// HOOKS
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../hooks/context/AuthContext";
import { IGetReportResponseItem } from "../../../hooks/apis/useIhrApi";
import { formatUtcDateStringInZone } from "../../../utils/dateTime";
import GenericButton from "../../ui/buttons/GenericButtons/GenericButton";
import LoadingSpinner from "../../ui/modals/Spinners/LoadingSpinner";
import WithNavLayout from "../../layout/WithLayout/WithNavLayout";

interface IReportsProps {
    className?: string;
    [key: string]: any;
}

const Reports: React.FC<IReportsProps> = ({ className = "", ...rest }) => {
    const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
    const navigate = useNavigate();
    const { token, reports, isLoading, getReports } = useAuthContext();
    const isLoaded = useRef(false);

    useEffect(() => {
        if (!isLoaded.current) {
            getReports(token ?? "");
            isLoaded.current = true;
        }
    }, [token, getReports]);

    useEffect(() => {
        setShowLoadingSpinner(isLoading);
    }, [isLoading]);

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <LoadingSpinner raised={showLoadingSpinner} fullPage={true} />
            <WithNavLayout>
                <div className={`Reports ${className}`} {...rest}>
                    <h2 className="Reports__heading">Shareable Reports</h2>
                    <div className="Reports__grid">
                        {reports.map(
                            (report: IGetReportResponseItem, idx: number) => (
                                <div className="Reports__card" key={idx}>
                                    <div className="Reports__info">
                                        <p>
                                            <strong>From:</strong>{" "}
                                            {formatUtcDateStringInZone(
                                                report.fromTimestampUtc,
                                            )}
                                        </p>
                                        <p>
                                            <strong>To:</strong>{" "}
                                            {formatUtcDateStringInZone(
                                                report.toTimestampUtc,
                                            )}
                                        </p>
                                        <p>
                                            <strong>Report ID:</strong>{" "}
                                            {report.reportId}
                                        </p>
                                        {/* <p>
                                            <strong>Secret Key:</strong>{" "}
                                            {report.secretKey}
                                        </p> */}
                                        <p>
                                            <strong>Sharing Enabled:</strong>{" "}
                                            {report.sharingEnabled
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </div>

                                    <GenericButton
                                        text="View"
                                        onClick={() =>
                                            navigate(
                                                `../report/${
                                                    report.reportId
                                                }?sk=${
                                                    report.secretKey
                                                }&hdr=${1}`,
                                            )
                                        }
                                    />
                                </div>
                            ),
                        )}
                    </div>
                </div>
            </WithNavLayout>
        </>
    );
};

export default Reports;
